// extracted by mini-css-extract-plugin
module.exports = {"list":"Confirm_list__5VUua","item":"Confirm_item__1f_uh","article":"Confirm_article__3X7CO","title":"Confirm_title__3w3zK","content":"Confirm_content__2YCMs"};